import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const heading = (theme: ExactTheme) => css`
  color: ${theme.colorsV2.red[500]};
`;

export const errorCode = (theme: ExactTheme) => css`
  font-size: 70px;
  line-height: 50px;
  font-weight: 600;
  color: ${theme.colorsV2.grey[900]};
`;

export const description = css`
  text-align: center;
  margin-top: 10px;
`;

export const root = css`
  height: 100%;
  padding: 15px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const inner = css`
  display: flex;
  min-height: 0;
  flex-direction: column;
  align-items: center;
`;
